export default __webpack_public_path__ + "static/media/v-21.faaeca9a.svg";